<template>
  <div class="change__form" style="padding: 0">
    <AppInput
      class=""
      rules="required"
      v-bind="{
        bg: '#272c35',
        label: form.placeholder
      }"
      v-model="value"
    />
    <!-- <input
			class="input"
			:type="form.inputType ? form.inputType : 'text'"
			:placeholder="form.placeholder"
			:required="form.required"
			:min="form.min || form.length || form.minLength"
			:step="form.step ? form.step : 1"
			:max="form.length || form.maxLength"
			:pattern="(form.regexp && form.regexp.value) ? form.regexp.value : '*+'"
			v-model="value"
			/> -->
  </div>
</template>

<script>
import AppInput from "@/components/ui/AppInput.vue";
export default {
  name: "Form",
  props: ["form"],

  data: () => ({
    value: ""
  }),

  watch: {
    value(value, old) {
      this.$emit("formValue", { key: this.form.key, value });
    }
  },
  components: { AppInput }
};
</script>



// WEBPACK FOOTER //
// src/components/ui/Modals/Form.vue